// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"08a1485d","9":"39aed46e","178":"f88598bd","228":"c862394d","246":"3619854d","333":"e8ac1714","453":"35185cbd","485":"d6c2c975","565":"491e70a5","567":"c7b52515","814":"9d0580d1","840":"531c4258","847":"2e53d756","862":"e99bc090","923":"22a272f6","948":"4e7163ef"}[chunkId] + ".chunk.js";
};